import Rating from './Rating'
import { Container } from './styles'

export default function RatingList ({ ratings = [] }) {
  return (
    <Container>
      {ratings.map (rating => (
        <Rating key={rating.id} data={rating}/>
      ))}
    </Container>
  )
}
